import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { EAlign } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useAlignSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.left),
                value: EAlign.Left,
            },
            {
                label: intl.formatMessage(message.right),
                value: EAlign.Right,
            },
            {
                label: intl.formatMessage(message.center),
                value: EAlign.Center,
            },
        ],
        [intl],
    )
}
